import { render, staticRenderFns } from "./categoryRow.vue?vue&type=template&id=29518af0&"
import script from "./categoryRow.vue?vue&type=script&lang=js&"
export * from "./categoryRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports